@if (errorMessage()) {
  <div class="alert alert-danger">
    <button type="button" class="close" (click)="errorMessage.set(null)">
      <span aria-hidden="true">&times;</span>
    </button>
    {{ errorMessage() }}
  </div>
}
@if (photos().length && task) {
  <task-photos
    [photos]="photos()"
    [diagnosis]="diagnosis()"
    [types]="photoTypes()"
    [visit]=visit
    [errorMessage]="errorMessage()"
    [isUpdatingPhoto]="cannotUpdatePhoto()"
    (reloaded)="reload()"
    (rejected)="reject($event)"
    (approved)="approve($event)"
  ></task-photos>
}
@if (additionalPhotos().length && task) {
  <p class="additional-photo-header">Additional ID Photos</p>
  <task-photos
    [photos]="additionalPhotos()"
    [diagnosis]="additionalDiagnosis()"
    [types]="photoTypes()"
    [visit]=visit
    [errorMessage]="errorMessage()"
    (reloaded)="reload()"
    (rejected)="reject($event)"
    (approved)="approve($event)"
  ></task-photos>
}

<!--Only show photoStatus if there is no additional ID Photos-->
<!--Only done this way since it was originally for 5 then they asked for just one for now-->
<!--Easier to reopen the other additional ID requests for V2 remove !additionalPhotos.length to show actual message-->
<div class="additional-photo-infos {{photos() ? 'hasPhotos': ''}}">
  @if (cannotRequest()) {
    <p>{{cannotRequestMessage()}}</p>
  }
  @if (canRequestMore && remainingRequests() === 0) {
    <p>
      You can only request a maximum of 4 additional pairs.
    </p>
  }
  @if (canRequestMore && remainingRequests() !== 0) {
    <p>
      You can request {{ remainingRequests() }} more pair{{ remainingRequests() === 1 ? '' : 's' }} of photos.
    </p>
  }
  @if (!cannotRequest()) {
    <p>
      You can request for additional photos.
    </p>
  }
    <button class="btn btn-green" [disabled]="cannotRequest()" (click)="openMessageDialog()">
        Request ID and Selfie
    </button>
</div>
